export function About() {
  return (
    <div>
      <h2 className="font-extrabold">ABOUT</h2>
      <p className="mt-4 text-slate-400">
        I'm a fullstack engineer with vast experience in backend development. I
        enjoy creating impact, with a talent for creating clean,
        self-documenting code.
        <br /> <br />I currently work for{" "}
        <a
          href="https://www.lloydsbankinggroup.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-slate-200 hover:text-slate-300"
        >
          Lloyds Banking Group
        </a>
        , where I currently develop data pipelines for crucial internal data
        reporting.
        <br />
        <br />I hold a Masters Degree in Computer Science from the{" "}
        <a
          href="https://www.leeds.ac.uk/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-slate-200 hover:text-slate-300"
        >
          University of Leeds
        </a>
        , graduating with First Class Honours. During my degree, I authored
        dissertations in Network Function Virtualisation and Surgical Artificial
        Intelligence.
        <br /> <br />I have authored three publications in the field of Surgical
        Data Science, one in the capacity of primary author.
      </p>
    </div>
  );
}
